export enum ContactTypeEnum {
  Counselor = 1,
  Director = 2,
  Manager = 3,
  Partner = 4,
  Legal = 5,
  Administrator = 6,
  Other = 7,
  Operator = 8,
  Support = 9,
}

